/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_Optimize_ButtonInputs */

const en_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimize ATS Score →`)
};

const de_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Score optimieren →`)
};

const fr_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimiser le score ATS →`)
};

const es_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimizar puntuación ATS →`)
};

const it_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottimizza punteggio ATS →`)
};

const nl_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-score optimaliseren →`)
};

const pl_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optymalizuj wynik ATS →`)
};

const fi_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimoi ATS-pisteet →`)
};

const da_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimer ATS-score →`)
};

const sv_ats_score_optimize_button = /** @type {(inputs: Ats_Score_Optimize_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimera ATS-poäng →`)
};

/**
* | output |
* | --- |
* | "Optimize ATS Score →" |
*
* @param {Ats_Score_Optimize_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_optimize_button = /** @type {((inputs?: Ats_Score_Optimize_ButtonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_Optimize_ButtonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_optimize_button(inputs)
	if (locale === "fr") return fr_ats_score_optimize_button(inputs)
	if (locale === "es") return es_ats_score_optimize_button(inputs)
	if (locale === "it") return it_ats_score_optimize_button(inputs)
	if (locale === "nl") return nl_ats_score_optimize_button(inputs)
	if (locale === "pl") return pl_ats_score_optimize_button(inputs)
	if (locale === "fi") return fi_ats_score_optimize_button(inputs)
	if (locale === "da") return da_ats_score_optimize_button(inputs)
	if (locale === "sv") return sv_ats_score_optimize_button(inputs)
	return en_ats_score_optimize_button(inputs)
});